import { render, staticRenderFns } from "./common-page.vue?vue&type=template&id=586e26ae"
import script from "./common-page.vue?vue&type=script&lang=js"
export * from "./common-page.vue?vue&type=script&lang=js"
import style0 from "./common-page.vue?vue&type=style&index=0&id=586e26ae&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports